const STATE_STYLE = {
  normal: { color: "#00C853", filled: true },
  watch: { color: "#FFB300", filled: false },
  warning: { color: "#FFB300", filled: true },
  high: { color: "#FF3B30", filled: false },
  critical: { color: "#FF3B30", filled: true, pulse: true },
  unknown: { color: "#71717A", filled: true, hatch: true },
};

export function StatusDot({ state = "normal", showLabel = true }) {
  const s = STATE_STYLE[state] || STATE_STYLE.normal;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`status-dot-${state}`}>
      <span
        className={`inline-block w-2.5 h-2.5 rounded-full ${s.pulse ? "pulse-glow" : ""}`}
        style={{
          backgroundColor: s.filled ? s.color : "transparent",
          border: `1.5px solid ${s.color}`,
          backgroundImage: s.hatch ? "repeating-linear-gradient(45deg, #71717A 0, #71717A 1px, transparent 1px, transparent 4px)" : undefined,
        }}
      />
      {showLabel && (
        <span className="text-[10px] font-heading uppercase tracking-wide text-[var(--oim-text-muted)]">
          {state === "unknown" ? "UNKNOWN" : state}
        </span>
      )}
    </span>
  );
}
